<template>
    <div class="header-wrap">
        <span class="font-8">{{ name }} status</span>
    </div>
</template>

<script>
import consts from 'services/metaData/consts';

export default {
    name: 'Header',
    props: {
        name: {
            type: String
        }
    },
    data() {
        return {
            consts
        };
    }
};
</script>

<style scoped lang="scss">
@import "~styles/buttons";
@import "~styles/styleGuide.scss";

.header-wrap {
    padding: 12px;
    border-bottom: 1px solid $light-500;
}
</style>
